import { IGroupChatData } from "@home-health-notify/domain";
import DraftsIcon from "@mui/icons-material/Drafts";
import { Box } from "@mui/material";
import { sortByDate, UserDirectoryContext } from "hhn-commons";
import { useContext } from "react";
import { PatientDetailText } from "./PatientGroupChatListItem.style";

export const PendingReferralsDetail = ({
  chatData,
}: {
  chatData: IGroupChatData;
}) => {
  const { userDirectory } = useContext(UserDirectoryContext);
  const pendingReferrals = chatData.groupInfo.pendingReferrals || [];
  const sortedPendingReferrals = sortByDate(pendingReferrals);
  return (pendingReferrals.length > 0 && (<Box
    data-testid="pending-referrals"
    sx={{
      display: "flex",
      flexDirection: "row",
      marginTop: "2px",
      alignItems: "center"
    }}>
    <DraftsIcon
      titleAccess="Pending Referrals"
      color="error"
      style={{
        height: "15px",
        width: "15px",
        marginLeft: "2px",
      }}
    />
    <PatientDetailText>
      {sortedPendingReferrals
        .map(referral => {
          const user = userDirectory.getUserInfo(referral.userId);
          return user.firstName;
        })
        .join(", ")}
    </PatientDetailText>
  </Box>));
};
